<template>
  <div>
    <div class="tips-top clearfix">
      <div class="left">操作提示：</div>
      <div class="right">
        <p>1.此功能仅用于临时清理网站的缓存，请勿频繁使用，避免影响网站性能。</p>
        <p>2.使用时尽量针对对应页面进行清理，清理范围不要过大。如楼盘相关的就不需要清理楼讯页面。</p>
        <p>3.每个页面半小时内仅可清理一次。清理完成后需等待页面进行更新，无需重复提交清理。</p>
      </div>
    </div>
    <div class="form-group-style">
      <el-form class="form-container" :model="cacheForm" :rules="cacheformRules" ref="cacheForm">
        <div class="form-item">
          <div class="form-label">
            <span class="label">站点</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="site_id">
              <site-auto-complete  v-model="cacheForm.site_id"  :owned='1' clearable></site-auto-complete>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">页面</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="page">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
              >全选</el-checkbox>
              <div style="margin: 15px 0;"></div>
              <el-checkbox-group v-model="checkedPages" @change="handleCheckedChange">
                <el-checkbox v-for="(item, key) in pages" :label="item" :key="key">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
        </div>
        <div class="tips" v-if="showTip">清理完成！</div>
        <div class="form-button">
          <el-button
            type="primary"
            v-permission="'cache.cache.clean'"
            @click="submitForm('cacheForm')"
          >保 存</el-button>
          <el-button type="info" plain @click="toWelcome()">取 消</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getSite } from "@/service/site";
import { cacheClean } from "@/service/user";
import SiteAutoComplete from "../../components/auto-complete/site-auto-complete";
export default {
  name: "List",
  components: {
    SiteAutoComplete
  },
  data() {
    return {
      site_ids:'',
      cacheForm: {
        site_id: "",
        page:[],
      },
      showTip:false,
      pages: [
        {
          val: 'home',
          name: "首页"
        },
        {
          val: 'news_list',
          name: "楼讯列表"
        },
         {
          val: 'house_list',
          name: "楼盘列表"
        }
      ],
      checkedPages: [],
      isIndeterminate: true,
      checkAll: false,
      cacheformRules: {
        site_id: [
          { required: true, message: "请选择站点", trigger: "blur" }
        ],
        page: [
          {
            required: true,
            message: "请至少选择一个页面",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {},
  mounted() {
  },
  methods: {
    handleCheckAllChange(val) {
      this.checkedPages = val ? this.pages : [];
      this.isIndeterminate = false;
      this.cacheForm.page= this.checkedPages
    },
    handleCheckedChange(value) {
        this.cacheForm.page= this.checkedPages;
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.pages.length;
        this.isIndeterminate =
            checkedCount > 0 && checkedCount < this.pages.length;
       
    },
    submitForm(formName) {
    
      this.$refs[formName].validate(valid => {
        if (valid) {
            let page =this.cacheForm.page;
            let pages=[]
            page.forEach((el)=>{
              pages.push(el.val)
            })
            let data={
              page:pages.join(','),
              site_id:this.cacheForm.site_id
            }
            cacheClean(data)
            .then(data => {
              this.showTip=true;
              setTimeout(() => {
                this.showTip=false;
              }, 2000)
              this.resetForm()
            })
            .catch(err => {
              //this.resetForm()
              const message =  err.message;
              this.$message({
                message: message || "清除失败",
                type: "error",
                duration: 3 * 1000
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.cacheForm && this.$refs.cacheForm.clearValidate()
      this.cacheForm.site_id=''
      this.cacheForm.page=[]
      this.checkedPages=[]
      this.checkAll=false
    },
    toWelcome() {
      this.$router.push("/home/index/welcome");
    }
  }
};
</script>
<style scoped lang="less">
.form-group-style {
  min-height: 600px;
  background-color: #fff;
}
.tips{
    font-size:20px;
    font-weight: bold;
    color:red;
    line-height:100px;
    margin-left:30%
}
.tips-top{
  width:100%;
  background: #fff;
  font-size: 14px;
}
.tips-top .left{
  width: 30%;
  float: left;
  text-align: right;
  line-height:30px;
}
.tips-top .right{
  width: 70%;
  float: left;
}
.tips-top .right p{
  line-height:30px;
}
</style>